<template>
  <div class="login">
    <van-nav-bar fixed left-arrow @click-left="$router.back()" title="货主注册"></van-nav-bar>
    <div class="cont">
      <van-form @submit="onSubmit">
        <div class="form-box">
          <van-field
            v-model="name"
            placeholder="请输入公司名称"
            clearable
            :rules="[{ required: true, message: '请输入公司名称' }]"
          ></van-field>
          <van-field
            readonly
            clickable
            name="picker"
            :value="carmodel"
            placeholder="点击选择城市"
            @click="showPicker = true"
          ></van-field>
          <van-field
            v-model="name"
            placeholder="请输入详细地址"
            clearable
            :rules="[{ required: true, message: '请输入详细地址' }]"
          ></van-field>
          <van-field
            v-model="name"
            placeholder="请输入联系人姓名"
            clearable
            :rules="[{ required: true, message: '请输入联系人姓名' }]"
          ></van-field>
          <van-field
            v-model="name"
            placeholder="请输入联系人"
            clearable
            :rules="[{ required: true, message: '请输入联系人' }]"
          ></van-field>
          <van-field name="uploader" label="营业执照">
            <template #input>
              <van-uploader v-model="uploader" />
            </template>
          </van-field>
        </div>
        <div class="form-btn">
          <van-button block type="info" native-type="submit">
            注册
          </van-button>
        </div>
      </van-form>
    </div>
    <van-popup
      v-model="showPicker"
      position="bottom"
    >
      <van-area
        :area-list="areaList"
        value="610000"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      ></van-area>
    </van-popup>
  </div>
</template>

<script>
import AreaList from "@/untils/area";
export default {
  name: "Register",
  data() {
    return {
      areaList: AreaList,
      name:'',
      carmodel:'',
      sms:'',
      uploader: [{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' }],
      showPicker:false
    };
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onConfirm(value) {
        console.log(value)
      let areaName = "";
      for (let i = 0; i < value.length; i++) {
        if(value[i]){
          areaName = areaName + value[i].name + " ";
        }
      }
      this.carmodel = areaName;
      this.showPicker = false;
    },
    onSubmit(values) {
      console.log('submit', values);
    }
  },
  destroyed() {
  }
};
</script>
<style scoped lang="less">
  @import '../../styles/login.less';
</style>



// WEBPACK FOOTER //
// src/pages/Login/RegisterInfo.vue